import { render, staticRenderFns } from "./instfooter.vue?vue&type=template&id=0273b5cf&scoped=true"
import script from "./instfooter.vue?vue&type=script&lang=js"
export * from "./instfooter.vue?vue&type=script&lang=js"
import style0 from "./instfooter.vue?vue&type=style&index=0&id=0273b5cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273b5cf",
  null
  
)

export default component.exports